import React from 'react';
import MenuCourseEdit from './MenuCourseEdit';
import MenuCourseView from './MenuCourseView';

class MenuCourses extends React.Component {
  render() {
    return (
      <div className="cms__content">
        {this.renderCourses()}
        {this.renderAddCourseButton()}
      </div>
    );
  }

  renderCourses() {
    const {
      deleteCourse,
      updateCourse,
      menu,
      isEdit,
      openModal,
      deleteDish,
      editMenuDish
    } = this.props;
    const { courses } = menu;
    // additional props for edit
    const props = {
      deleteCourse,
      updateCourse,
      openModal,
      deleteDish,
      editMenuDish
    };

    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Menu</h3>
          </div>
        </div>
        {courses
          .sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1))
          .map((course, i) =>
            isEdit ? (
              <MenuCourseEdit key={i} index={i} course={course} {...props} />
            ) : (
              <MenuCourseView key={i} course={course} />
            )
          )}
      </div>
    );
  }
  renderAddCourseButton() {
    const { isEdit, addCourse } = this.props;
    if (isEdit)
      return (
        <div className="btn btn--white btn--full-width" onClick={addCourse}>
          + Add Course
        </div>
      );
  }
}

export default MenuCourses;



// WEBPACK FOOTER //
// ./src/components/menu/MenuCourses.js